class ItemPricingHelper {
  constructor(item, quantity) {
    this.item = item;
    this.quantity = quantity || 1;
  }

  getItemTotalPrice() {
    switch (this.item.pricing_model) {
      case "flat_fee":
        return this.flatFeeTotalPrice();
      case "per_unit":
        return this.perUnitTotalPrice();
      case "tiered":
        return this.tiredTotalPrice();
      case "stairstep":
        return this.stairStepTotalPrice();
      case "volume":
				return this.volumeTotalPrice();
			default:
				return 0;
    }
  }

  flatFeeTotalPrice() {
    return this.item.price;
  }

  perUnitTotalPrice() {
    return this.item.price * this.quantity;
  }

  tiredTotalPrice() {
    let out = this.item.tiers.reduce((inp, tier) => {
			if(inp.quantity < 1) {
				return inp;
			}
			if(tier.ending_unit && tier.ending_unit < inp.quantity) {
				return {total: inp.total + (tier.price * tier.ending_unit), quantity: (inp.quantity - tier.ending_unit)};
			} else {
				return {total: inp.total + (tier.price * inp.quantity), quantity: 0 };
			}
		}, {total: 0, quantity: this.quantity});
		return out.total;
  }

  stairStepTotalPrice() {
    let tiers = this.getMatchedTiers();
    if (tiers.length > 0) {
      return tiers[0].price;
    }
    return 0;
  }

  volumeTotalPrice() {
    let tiers = this.getMatchedTiers();
    if (tiers.length > 0) {
      return tiers[0].price * this.quantity;
    }
    return 0;
  }

  getMatchedTiers() {
    return this.item.tiers.filter(i =>
      i.starting_unit <= this.quantity && i.ending_unit
        ? i.ending_unit >= this.quantity
        : true
    );
  }
}

export default {

	getItemTotalPrice(item, quantity) {
		return new ItemPricingHelper(item, quantity).getItemTotalPrice();
	},
  periodUnitLabels(ref) {
    return {
      'day': {singular: ref.cmt('portal.term.daily'), plural: ref.cmt('portal.term.days')},
      'week': {singular: ref.cmt('portal.term.weekly'), plural: ref.cmt('portal.term.weeks')},
      'month': {singular: ref.cmt('portal.term.monthly'), plural: ref.cmt('portal.term.months')},
      'year': {singular: ref.cmt('portal.term.yearly'), plural: ref.cmt('portal.term.years')}
    }
  }
}
